// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieBanner_container__2rNrJ"};